import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.32265 17.5586C7.10306 17.573 6.92969 17.7551 6.92969 17.9785C6.92969 18.2116 7.11749 18.3994 7.35056 18.3994H12.3781C12.6112 18.3994 12.799 18.2116 12.799 17.9785C12.799 17.7551 12.6256 17.573 12.406 17.5586H12.3781H7.35054H7.32265Z",
			fill: "#FF9790"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.54688 19.168C8.70771 19.6505 9.16327 19.9982 9.69973 19.9982H10.032C10.5685 19.9972 11.024 19.6495 11.1849 19.168H8.54688Z",
			fill: "#FF9790"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.78363 4.50188C4.68154 4.50188 4.5833 4.46143 4.51106 4.38919L3.36109 3.23923C3.21085 3.08898 3.20988 2.8453 3.36109 2.69508C3.51134 2.54483 3.75502 2.54387 3.90524 2.69508L5.05425 3.846C5.29695 4.08871 5.12263 4.50382 4.78168 4.50286L4.78363 4.50188Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.16953 15.9897C7.16279 15.9936 7.15701 15.9964 7.15027 16.0003C7.01928 16.0716 6.93164 16.2103 6.93164 16.3701C6.93164 16.5936 7.105 16.7756 7.3246 16.79H7.35157C7.36217 16.79 7.37276 16.79 7.38239 16.791H12.3473C12.3579 16.79 12.3675 16.79 12.3781 16.79H12.4061C12.6256 16.7756 12.8 16.5936 12.8 16.3701C12.8 16.1371 12.6122 15.9493 12.3791 15.9493H7.35157C7.28608 15.9483 7.22443 15.9627 7.16953 15.9897Z",
			fill: "#FF9790"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.35561 15.1778H9.4812V13.1274L8.1656 11.8012C8.00861 11.6576 7.99706 11.4149 8.14056 11.257C8.29369 11.0894 8.55855 11.0894 8.71072 11.258L9.8655 12.4204L11.0203 11.258C11.1696 11.1068 11.4142 11.1058 11.5644 11.256C11.7156 11.4063 11.7166 11.65 11.5663 11.8002L10.2507 13.1264V15.1769H12.3802C12.3638 14.6231 12.4303 13.1399 13.5821 11.7924C14.3295 10.9111 14.7379 9.79295 14.7369 8.63719C14.7321 5.99632 12.5805 3.81873 9.94164 3.78125H9.86555C7.17858 3.78125 5 5.9598 5 8.6468C5 9.80734 5.4151 10.9294 6.16922 11.8106C6.97053 12.7487 7.39237 13.9497 7.35578 15.1776L7.35561 15.1778ZM6.13247 9.29325C5.91962 9.29325 5.74722 9.12085 5.74722 8.90801C5.74722 6.60618 7.63203 4.75796 9.9234 4.79174C10.1363 4.79463 10.3058 4.96992 10.3029 5.18179C10.3 5.39464 10.1247 5.56415 9.91283 5.56127C8.06365 5.53526 6.54387 7.01267 6.51774 8.86192C6.51774 8.8783 6.51678 8.89274 6.51678 8.90912C6.5187 9.121 6.34628 9.29325 6.13247 9.29325Z",
			fill: "url(#paint0_linear_6185_92708)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.86571 2.39624C9.65287 2.39624 9.48047 2.22384 9.48047 2.01099V0.385245C9.48047 0.172397 9.65287 0 9.86571 0C10.0786 0 10.251 0.172397 10.251 0.385245V2.01195C10.25 2.2248 10.0776 2.39624 9.86571 2.39624Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5625 4.11798C14.5625 4.01589 14.603 3.91862 14.6752 3.84637L15.8252 2.69544C15.9793 2.54905 16.2229 2.55579 16.3693 2.70989C16.5109 2.85917 16.5109 3.09129 16.3693 3.24056L15.2184 4.39148C14.9776 4.63226 14.5616 4.46085 14.5625 4.11798Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.6799 9.58299H17.0532C16.8404 9.58299 16.668 9.41059 16.668 9.19775C16.668 8.9849 16.8404 8.8125 17.0532 8.8125H18.6799C18.8928 8.8125 19.0652 8.9849 19.0652 9.19775C19.0642 9.41059 18.8928 9.58299 18.6799 9.58299Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.67797 9.58299H1.05126C0.838413 9.58299 0.666016 9.41059 0.666016 9.19775C0.666016 8.9849 0.838413 8.8125 1.05126 8.8125H2.67797C2.89082 8.8125 3.06321 8.9849 3.06321 9.19775C3.06225 9.41059 2.89082 9.58299 2.67797 9.58299Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_6185_92708",
			x1: 5,
			y1: 9.47954,
			x2: 14.7369,
			y2: 9.47954,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9790" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFB13B"
			})]
		}) })
	]
});
export { SvgTip as ReactComponent };
